import { Search } from "@mui/icons-material";
import { Box, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

interface IKeyDriveSearchBar {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value?: unknown;
}

export const KeyDriveSearchBar : React.FC<IKeyDriveSearchBar> = ({onChange, value}) => {

    const {t} = useTranslation();

    return (
        <Box sx={{
            height: '36px',
            display: 'flex',
            gap: '20px',
            padding: '0px',
            width: "100%"
        }}>
            <TextField
                fullWidth
                id="filled-basic"
                variant="filled"
                placeholder={t('AdminConsole.WhatAreYouLookingFor')}
                onChange={onChange}
                value={value}
                InputProps={{
                    disableUnderline: true,
                    startAdornment: (
                        <Box sx={{ display: 'flex', alignItems: 'center', paddingRight: '10px' }}>
                            <Search sx={{ color: "#22638D" }} />
                        </Box>
                    ),
                    sx: {
                        height: '36px',
                        padding: '0 10px',
                        '& .MuiFilledInput-input': {
                            height: '36px',
                            padding: '0 10px',
                            display: 'flex',
                            alignItems: 'center',
                        },
                        backgroundColor: "transparent",
                        border: "1px solid #E9EFF4"
                    },
                }}
            />
        </Box>
    )
}